import {
  FETCH_FIAT_DEPOSITS_FAILED,
  FETCH_FIAT_DEPOSITS_START,
  FETCH_FIAT_DEPOSITS_SUCCESS,
  FETCH_FIAT_WITHDRAWALS_FAILED,
  FETCH_FIAT_WITHDRAWALS_START,
  FETCH_FIAT_WITHDRAWALS_SUCCESS,
  FETCH_WALLET_REPORT_FAILED,
  FETCH_WALLET_REPORT_START,
  FETCH_WALLET_REPORT_SUCCESS,
  FETCH_WALLETS_FAILED,
  FETCH_WALLETS_START,
  FETCH_WALLETS_SUCCESS,
  REQUEST_WALLET_FX_TRANSFER_ERROR,
  REQUEST_WALLET_FX_TRANSFER_START,
  REQUEST_WALLET_FX_TRANSFER_SUCCESS,
} from './actionTypes'

export const fetchWallets = (params = {}) => {
  return {
    type: FETCH_WALLETS_START,
    payload: params,
  }
}
export const fetchWalletsFailed = (error) => {
  return {
    type: FETCH_WALLETS_FAILED,
    payload: error,
  }
}
export const fetchWalletsSuccess = (params) => {
  return {
    type: FETCH_WALLETS_SUCCESS,
    payload: params,
  }
}

export const createWalletTransfer = (data) => {
  return {
    type: REQUEST_WALLET_FX_TRANSFER_START,
    payload: data,
  }
}

export const createWalletTransferSuccess = (data) => {
  return {
    type: REQUEST_WALLET_FX_TRANSFER_SUCCESS,
    payload: data,
  }
}

export const createWalletTransferError = (error) => {
  return {
    type: REQUEST_WALLET_FX_TRANSFER_ERROR,
    payload: error,
  }
}

export const fetchReport = (params = {}) => {
  return {
    type: FETCH_WALLET_REPORT_START,
    payload: params,
  }
}

export const fetchReportSuccess = (params) => {
  return {
    type: FETCH_WALLET_REPORT_SUCCESS,
    payload: params,
  }
}

export const fetchReportFailed = (error) => {
  return {
    type: FETCH_WALLET_REPORT_FAILED,
    payload: error,
  }
}

export const fetchFiatDeposits = (params = {}) => {
  return {
    type: FETCH_FIAT_DEPOSITS_START,
    payload: params,
  }
}

export const fetchFiatDepositsSuccess = (params) => {
  return {
    type: FETCH_FIAT_DEPOSITS_SUCCESS,
    payload: params,
  }
}

export const fetchFiatDepositsFailed = (error) => {
  return {
    type: FETCH_FIAT_DEPOSITS_FAILED,
    payload: error,
  }
}

export const fetchFiatWithdrawals = (params = {}) => {
  return {
    type: FETCH_FIAT_WITHDRAWALS_START,
    payload: params,
  }
}

export const fetchFiatWithdrawalsSuccess = (params) => {
  return {
    type: FETCH_FIAT_WITHDRAWALS_SUCCESS,
    payload: params,
  }
}

export const fetchFiatWithdrawalsFailed = (error) => {
  return {
    type: FETCH_FIAT_WITHDRAWALS_FAILED,
    payload: error,
  }
}

